import React from 'react'
import { createContainer } from '@dbk-legacy/muster/react';
import  Spinner from '@dbk/ui-spinner';
import TradeSecurityPriceChart from './trade-security-price-chart';

class TradePriceHistoryChart extends React.PureComponent {

  componentDidMount() {
    const { positionCurrency: psCcy, subAssetsDesc, number, ricCode } = this.props.row
    const num_days = 5;
    this.props.getSingleSecurityDetail(number && number);
    if (subAssetsDesc) {
      this.props.priceHistory.getData({
        psActNmb: number && number,
        subAssetsDesc,
        ricCode,
        psCcy,
        num_days
      })
    }
  }

  render () {
    const {
      priceHistory: { data, fetchInProgress },
      row: { subAssetsDesc },
      positionEntry: { trade }
    } = this.props

    if (!subAssetsDesc) return null

    if(fetchInProgress && trade.fetchInProgress) return <div className="asset-position-expand-spinner"><Spinner testID="spnr_trade_security_detail_test" accessibilityLabel="spnr_trade_security_detail_test"/></div>

    if (!data) return null

    const chartData = JSON.parse(data);
    const code = (chartData && chartData.length > 0 && 
                chartData[0].priceCurrency && chartData[0].priceCurrency.code ? chartData[0].priceCurrency.code : '');
                   
    if(!code) return null;

    const priceHistory = JSON.parse(data).map(({ psMktPrc, psAvaBal, psMktPrcDte, asOfDate }) => ({
      x: (psMktPrcDte && new Date(psMktPrcDte)) || (asOfDate && new Date(asOfDate)) || new Date(),
      y: psMktPrc || psAvaBal || 0
    }))

    return (
        <TradeSecurityPriceChart
          langCode={this.props.auth.langCode}
          chartData={priceHistory}
          currencyCode={code} />
    )
  }
}

export default createContainer({
  $queries: {
    priceHistory: {
      getData: { $call: 'getDataTrading' },
      data: true,
      fetchInProgress:true,
    },
    auth: {
      langCode: true
    },
    positionEntry: {
      trade: { security : true , fetchInProgress: true}
    },
    getSingleSecurityDetail: { $call: 'positionEntry.getSingleSecurityDetail'}
}
})(TradePriceHistoryChart)